import { PlaceType } from 'core/type/Places.types';
import { AirportCode, DisplayNames } from 'core/type/BootstrapConfig.types';
import { TextSearchType } from 'core/type/TextSearch.types';
import { IconId } from '@drone-js/core';

export enum EmptyStateItemType {
    TopActivities = 'TopActivities',
    PopularDestinations = 'PopularDestinations',
}

export interface SearchResult {
    cityId: number;
    cityName: string;
    url: string;
    type: TextSearchType;
    isCityPageEligible?: boolean;
}

export interface SuggestionResult {
    id: number;
    name: string;
    nameTranslated: string;
    placeType: PlaceType;
    areaId: number;
    areaName?: string;
    areaNameTranslated?: string;
    cityId: number;
    cityName: string;
    cityNameTranslated: string;
    cityAbbr: string;
    countryId: number;
    countryName: string;
    countryNameTranslated: string;
    countryISO2: string;
    stateId: number;
    stateName: string;
    stateNameTranslated: string;
    supplierId?: number;
    type: TextSearchType;
    activityId: number;
    activityName?: string;
    activityNameTranslated?: string;
    latitude: number;
    longitude: number;
    isPopular: boolean;
    whiteLabelToken: string;
    airportCodes?: AirportCode[];
    displayNames: DisplayNames;
    objectTypeId: number;
    addressId?: number;
    isAddress: boolean;
    isCityPageEligible?: boolean;
    isBestSeller: boolean;
    isSubSuggestion: boolean;
    url: string;
    categories?: Category[];
    topCategories?: Category[];
}

export interface RecentSearchItem {
    id: number;
    type: TextSearchType;
    activityName: string;
    url: string;
    cityName: string;
    countryName: string;
    cityId: number;
    isUrlWithPrefix?: boolean;
    isCityPageEligible?: boolean;
    categoryCode?: string;
    emptyStateType?: EmptyStateItemType;
    supplierId?: number;
}

export interface Category {
    id: number;
    code: string;
}

export interface SuggestionItem {
    activityId: number;
    activityName: string;
    activityNameTranslated?: string;
    categoryCms: number;
    categories?: Category[];
    cityId: number;
    cityName: string;
    cityNameTranslated?: string;
    countryName: string;
    countryNameTranslated?: string;
    icon: IconId;
    id: number;
    isCityPageEligible?: boolean;
    type: TextSearchType;
    url: string;
    supplierId?: number;
}

export interface SuggestionGroup {
    origin: string;
    items: SuggestionItem[];
}
